import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './bodor/HeroSection';
import { CategoryCardsSection } from './bodor/CategoryCardsSection';
import { HighlightsAndResourcesSection } from './bodor/HighlightsAndResourcesSection';
import { HighPowerSection } from './bodor/HighPowerSection';
export function BodorPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1032">
      <SeoBar data-id="element-1033" />
      <Header data-id="element-1034" />
      <main className="flex-grow" data-id="element-1035">
        <div className="w-full bg-white pb-20" data-id="element-1036">
          <HeroSection data-id="element-1037" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 relative z-20" data-id="element-1038">
            <CategoryCardsSection data-id="element-1039" />
            <HighlightsAndResourcesSection data-id="element-1040" />
            <HighPowerSection data-id="element-1041" />
          </div>
        </div>
      </main>
      <Footer data-id="element-1042" />
    </div>;
}